import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import { isEqual } from "lodash";
import { API_URL } from "../../../helpers/app_url";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  FormGroup,
  Label,
  Input,
  InputGroup,
} from "reactstrap";
import { connect } from "react-redux";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import CopyText from "components/buttons/copyBtn";
import SafeHTML from "components/buttons/SafeHTML";
import SafeField from "helpers/SafeField";
class PublishPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageData: "",
      projectData:'',
    };
    this.previewSubmit = this.previewSubmit.bind(this);
  }
  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = "Bearer " + token;
      axios.get(API_URL + `ProjectLandingPage/${this.props.match.params.id}`, { headers: { Authorization: str } })
      .then(res => {
        const pageData = res.data;
        this.setState({ pageData: pageData });  
      });

      axios.get(API_URL + `ProjectExt/guid?projectid=${this.props.match.params.projectId}`, { headers: { Authorization: str } })
      .then(res => {
        const projectData = res.data;
        this.setState({
          projectData: projectData,
        });  
      });
  }
  handleSubmit = (values, { setSubmitting }) => {
    //
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = "Bearer " + token;
    axios.put(API_URL + `ProjectLandingPage`, values, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': str
      }
    })
      .then(response => {
        
        this.props.history.push(`/pre-construction/campaign/landing-page/${this.props.match.params.projectId}`)
      })
      .catch(error => {
        console.error('Error submitting form:', error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

   removeFormTags = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    //doc.querySelectorAll('form').forEach(form => form.remove());
    doc.querySelectorAll('input[required], textarea[required], select[required]').forEach(el => {
      el.removeAttribute('required');
    });
    return doc.body.innerHTML;
  };
  previewSubmit = () => {
    const payload = {
                    id: this.state.pageData.id,
                    projectLandingPageId: this.state.pageData.projectLandingPageId,
                    landingPageProjectId: this.state.pageData.landingPageProjectId,
                    landingPageProjectGuid:this.state.pageData.landingPageProjectGuid,
                    landingPageTemplateId: this.state.pageData.landingPageTemplateId,
                    landingPagePermaLink: this.state.pageData.landingPagePermaLink,
                    landingPageContent:  this.state.pageData.landingPageContent,
                    landingPageCss: this.state.pageData.landingPageCss,
                    landingPageFullContent: this.state.pageData.landingPageFullContent,
                    agentId: this.state.pageData.agentId,
                    isActive: this.state.pageData.isActive,
                    landingPagePublishStatus: this.state.pageData.landingPagePublishStatus,
                    landingPageUrl : `https://pages.realtyspacehub.com/${this.props.match.params.projectId}`, 
                    landingPageTitle:this.state.projectData.projectName
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = "Bearer " + token;
    axios.put(API_URL + `ProjectLandingPage/previewProjectLandingPageinfo`, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': str
      }
    })
      .then(response => {
        
       this.props.history.push({
          pathname: `/pre-construction/preview-page/${this.props.match.params.id}/${this.props.match.params.projectId}/${this.props.match.params.templateId}`,
          state: { previewData: response.data }
        });

      })
      .catch(error => {
        console.error('Error submitting form:', error);
      })
    //
  };
  render() {
    
    return (
    
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Create Template | Realty Space</title>
          </MetaTags>
          <ToastContainer autoClose={2000} />
          <Container fluid>
            <div className="overlay-email">
              
                
                    {/* Render Breadcrumb */}
                    
                  
                    <Row className="mb20">
                                <Col sm="12">
                                
                                </Col>
                
                    </Row>
                    <Row>
                    <Col lg="8">
                    <span className="float-start mt-20" style={{marginLeft:20}}>
                        <RsLink className="btn btn-light btn-md" iconClass="bx bx-arrow-back" to={`/pre-construction/campaign/landing-page/` + this.props.match.params.projectId}>
                            Back
                        </RsLink>
                        </span>
                      <div className="m-4  card mt-80">
                        <SafeHTML html={this.state.pageData.landingPageFullContent} />
                      {/* { <div dangerouslySetInnerHTML={{__html:this.state.pageData.landingPageFullContent}}></div> }  */}
                        </div>
                      </Col>
                    <Col lg="4">
                   
                    <Formik
                enableReinitialize={true}
                initialValues={{
                  
                    id: this.state.pageData.id,
                    projectLandingPageId: this.state.pageData.projectLandingPageId,
                    landingPageProjectId: this.state.pageData.landingPageProjectId,
                    landingPageProjectGuid: this.state.pageData.landingPageProjectGuid,
                    landingPageTemplateId: this.state.pageData.landingPageTemplateId,
                    landingPagePermaLink: this.state.pageData.landingPagePermaLink,
                    landingPageContent:  this.state.pageData.landingPageContent,
                    landingPageCss: this.state.pageData.landingPageCss,
                    landingPageFullContent: this.state.pageData.landingPageFullContent,
                    agentId: this.state.pageData.agentId,
                    isActive: this.state.pageData.isActive,
                    landingPagePublishStatus: this.state.pageData.landingPagePublishStatus,
                    landingPageUrl : `https://pages.realtyspacehub.com/${this.props.match.params.projectId}`, 
                    landingPageTitle:this.state.projectData.projectName,
                    landingPageDescription:'',
                    landingEmailForEnquiry:''
                }}
                validationSchema={Yup.object().shape({
                  
                })}
                onSubmit={this.handleSubmit}
               
              >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                  <Form className="needs-validation">
                  
                     <span className="float-end mt-20" style={{marginRight:20}}>
                     <a href={`https://pages.realtyspacehub.com/preview/${this.props.match.params.projectId}`} target="_blank" rel="noreferrer" className="btn btn-primary"> Preview Landing Page </a>{" "}
                      <SaveButton> Publish Page </SaveButton>
                        </span>
                            <div className="clearfix"></div>
                        <Card className="m-4">

                          <CardBody>
                            <Row className="p-4 langing-page">

                              <Col sm="12" className="border">
                              <h2>Page Url <CopyText textToCopy={values.landingPageUrl} /></h2>
                                <FormGroup className="mb-3">
                                  
                                  <SafeField
                                    name="landingPageUrl"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.landingPageUrl &&
                                      touched.landingPageUrl
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="landingPageUrl"
                                  />
                                  <ErrorMessage
                                    name="landingPageUrl"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="12" className="border">
                              <h2>Page Title</h2>
                                <FormGroup className="mb-3">
                                 
                                  <SafeField
                                    name="landingPageTitle"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.landingPageTitle &&
                                      touched.landingPageTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="landingPageTitle"
                                  />
                                  <ErrorMessage
                                    name="landingPageTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                             
                              <Col sm="12" className="border">
                              <h2>Any Page Description</h2>
                                <FormGroup className="mb-3">
                                 
                                <SafeField
                                    name="landingPageDescription"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.landingPageDescription &&
                                      touched.landingPageDescription
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="landingPageDescription"
                                  />
                                  <ErrorMessage
                                    name="landingPageDescription"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>

                              <Col sm="12" className="border">
                              <h2>CC Email for Enquiry Form</h2>
                                <FormGroup className="mb-3">
                                 
                                <SafeField
                                    name="landingEmailForEnquiry"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.landingEmailForEnquiry &&
                                      touched.landingEmailForEnquiry
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="landingEmailForEnquiry"
                                  />
                                  <ErrorMessage
                                    name="landingEmailForEnquiry"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                             
                              <Col sm="6"></Col>
                            </Row>
                          </CardBody>
                        </Card>
                        </Form>
                      )}
                          </Formik>
                     
                    </Col>
                    
                      </Row>

            </div>
          </Container>

        </div>
      </React.Fragment>
    );
  }
}
PublishPage.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history: PropTypes.object,
};
const mapStateToProps = ({}) => ({});
const mapDispatchToProps = dispatch => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PublishPage));
